module.exports = __webpack_public_path__ + "img/1-2.2c2ff533.svg";